import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Spinner from '../Spinner/Spinner';

interface MaintenanceCheckProps {
  baseUrl?: string;
  maintenanceUrl: string;
  message: React.ReactNode | React.ReactNode[];
  children?: React.ReactNode | React.ReactNode[];
  hideLoader?: boolean;
  services?: string[];
}

const MaintenanceCheck = ({
  children,
  baseUrl = null,
  maintenanceUrl,
  message,
  hideLoader = false,
  services = []
}: MaintenanceCheckProps) => {
  const [searchParams] = useSearchParams();
  const [isBusinessCheckout, setIsBusinessCheckout] = useState(
    sessionStorage.getItem('businessCheckout') === 'true' || false
  );

  const { isLoading, data, isSuccess } = useQuery({
    queryKey: ['maintenance'],
    queryFn: async () => {
      const { data } = await axios<Record<string, boolean>>({
        method: 'GET',
        baseURL: baseUrl,
        url: maintenanceUrl
      });

      return data;
    }
  });

  useEffect(() => {
    if (searchParams.get('businessCheckout')) {
      sessionStorage.setItem('businessCheckout', searchParams.get('businessCheckout'));
      setIsBusinessCheckout(searchParams.get('businessCheckout') === 'true');
    }
  }, []);

  if (isLoading && !hideLoader) {
    return <Spinner message="Loading" isFullscreen isBranded />;
  }

  // if the API call was successful and any of the services in maintenance.json are set to true
  // then we should render the maintenance message, unless the business checkout flag is true
  if (
    isSuccess &&
    Object.keys(data).some((service) => data[service] && services.includes(service)) &&
    !isBusinessCheckout
  ) {
    return <>{message}</>;
  }

  return <>{children}</>;
};

export default MaintenanceCheck;
